import { zksync as viemZksync } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const zksync = {
  displayName: 'ZKsync Era',
  runtime: 'evm',
  viemChain: viemZksync,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'zksync-era' },
    qnStreams: {
      networkKey: 'zksync-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
